import useOffer from '../../../../hooks/Offers/useOffer'
import useOfferMetaData from '../../../../hooks/Offers/useOfferMetaData'
import { isHotel, isLEHotel } from '../../../../lib/offer/offerTypes'

interface GroupedHotelSearchTileSecondaryOfferState {
  secondaryOffer?: App.HotelOffer | App.HotelOfferSummary
  secondaryOfferMetaData?: App.OfferListMetaData
  fetching: boolean
}

function useGroupedHotelSearchTileSecondaryOffer(
  primaryOfferId: string,
  filters?: App.OfferListFilters,
): GroupedHotelSearchTileSecondaryOfferState {
  const primaryOfferMetaData = useOfferMetaData(primaryOfferId, filters)
  const secondaryOfferId = primaryOfferMetaData?.secondaryOfferId
  const secondaryOfferMetaData = useOfferMetaData(secondaryOfferId ?? '', filters)

  const [secondaryOffer, fetching, error] = useOffer(secondaryOfferId, { requireSummaryOnly: true })
  // Grouped search tiles only support LE hotel secondaries; bedbank primary offers still upsell to LE flash offers.
  const validSecondaryOffer = isHotel(secondaryOffer) && isLEHotel(secondaryOffer) ? secondaryOffer : undefined

  return {
    secondaryOffer: validSecondaryOffer,
    secondaryOfferMetaData,
    fetching: (!!secondaryOfferId && !secondaryOffer && !error) || fetching,
  }
}

export default useGroupedHotelSearchTileSecondaryOffer
